import Country from '../../models/Country';
import { ApiAction, PaginatedApiState, initialPaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';

export interface CountriesState extends PaginatedApiState {
  countries?: Country[]
}

const Countries = (state: CountriesState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<CountriesState>('COUNTRIES_LIST')(state, action)
  }
}

export default Countries
